import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useApi from "../../hooks/useApi";
import useApp from "../../hooks/useApp";
import FileWidget from "../../widgets/FileWidget";
import Select from "react-select";

const ClientForm = (props) => {
  const [client, setClient] = useState({});
  const [dropDowns, setDropDowns] = useState({ user: [] });
  const { api, abortSignal, auth } = useApi();
  const { id } = useParams();
  const nameRef = useRef();
  const rmRef = useRef();
  const companyRef = useRef();
  const { showAlert } = useApp();
  const { scope = "add" } = props;
  const navigate = useNavigate();

  const getDropDowns = async () => {
    try {
      const models = ["user"];
      const { data } = await api.list(`/dropdowns`, models);
      if (data && typeof client.relationManager === "string")
        setClient({
          ...client,
          relationManager: data.user.find(
            (item) => item.value === client.relationManager
          ),
        });
      setDropDowns({ ...dropDowns, ...data });
      // setDropDowns(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!client.name.trim()) {
      nameRef.current.focus();
      return showAlert("Please enter name", "error");
    }
    try {
      const clientData = new FormData();
      for (const [key, value] of Object.entries(client)) {
        if (key === "relationManager") {
          clientData.append(key, value?.value || "");
        } else {
          clientData.append(key, value);
        }
      }
      let response =
        scope === "edit"
          ? await api.edit(`/clients/${id}`, clientData)
          : await api.add("/clients", clientData);
      if (response.ok) {
        scope === "edit"
          ? showAlert("Client profile updated", "success")
          : showAlert("Client added", "success");

        navigate(`/clients/${id ? id : response.data.id}`, { replace: true });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    scope === "add" && setClient({});
  }, [scope]);

  if (!client?.client_type) {
    setClient({ ...client, client_type: "individual" });
  }

  useEffect(() => {
    getDropDowns();
  }, [auth, client.relationManager]);

  useEffect(() => {
    // client?.client_type === "corporate" && nameRef.current.focus();
    const callApi = async () => {
      try {
        const response = await api.read(`/clients/${id}`);

        if (response.success) setClient(response.data?.info);
      } catch (error) {
        console.error(error);
      }
    };

    scope === "edit" && callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [auth]);

  const handleClientTypeChange = (e) => {
    setClient({
      ...client,
      client_type: e.target.value,
    });

    // nameRef.current.focus();
  };

  useEffect(() => {
    // console.log(client.client_type);
    client?.client_type === "corporate"
      ? companyRef.current.focus()
      : nameRef.current.focus();
  }, [client.client_type]);

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed">
        <div className="content__wrap">
          {/* <!-- Breadcrumb --> */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/desktop">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/clients">Client</Link>
              </li>

              <li className="breadcrumb-item active" aria-current="page">
                {scope === "edit" ? "Edit" : "Add"}
              </li>
            </ol>
          </nav>
          {/* <!-- END : Breadcrumb --> */}
          <h1 className="page-title mb-0 mt-2">
            {scope === "edit" ? "Edit" : "Add"} Client
          </h1>

          <p className="lead">
            {scope === "edit" ? "Edit" : "Add new"} Client record
          </p>

          <div className="d-md-flex align-items-baseline mt-3">
            <Link to="/clients" className="btn btn-info hstack gap-2 mb-3">
              <i className="demo-psi-file fs-4"></i>
              <span className="vr"></span>
              View Clients
            </Link>
          </div>
        </div>
      </div>

      <div className="content__boxed">
        <div className="content__wrap">
          <section>
            <div className="row">
              <div className="col-xxl-6 col-lg-12 col-md-12 mb-3">
                <div className="card h-100">
                  <form onSubmit={handleSave} autoComplete="off">
                    <div className="card-body">
                      <h5 className="card-title text-primary">Client Data</h5>
                      <div className="row mb-3">
                        <label className="col-sm-3 col-form-label text-primary">
                          Type of Client
                        </label>
                        <div className="col-sm-9">
                          <div className="form-check mb-2">
                            <input
                              id="clientType-individual"
                              className="form-check-input"
                              type="radio"
                              name="clientType"
                              value="individual"
                              checked={client?.client_type === "individual"}
                              onChange={(e) => handleClientTypeChange(e)}
                            />
                            <label
                              htmlFor="clientType-individual"
                              className="form-check-label"
                            >
                              Individual
                            </label>
                          </div>

                          <div className="form-check mb-2">
                            <input
                              id="clientType-corporate"
                              className="form-check-input"
                              type="radio"
                              name="clientType"
                              value="corporate"
                              checked={client?.client_type === "corporate"}
                              onChange={(e) => handleClientTypeChange(e)}
                            />
                            <label
                              htmlFor="clientType-corporate"
                              className="form-check-label"
                            >
                              Corporate
                            </label>
                          </div>
                        </div>
                      </div>
                      {client?.client_type === "corporate" && (
                        <div className="row mb-3">
                          <label
                            htmlFor="name"
                            className="col-sm-3 form-label text-primary"
                          >
                            Company Name
                          </label>
                          <div className="col-sm-9">
                            <div className="form-floating mb-3">
                              <input
                                ref={companyRef}
                                id="companyName"
                                type="text"
                                className="form-control"
                                placeholder="Company Name"
                                onChange={(e) =>
                                  setClient({ ...client, name: e.target.value })
                                }
                                value={client?.name || ""}
                                required
                              />
                              <label
                                htmlFor="companyName"
                                className="text-primary"
                              >
                                Company Name
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row mb-3">
                        <label
                          htmlFor="name"
                          className="col-sm-3 form-label text-primary"
                        >
                          {client?.client_type === "corporate"
                            ? "Contact Person"
                            : "Name"}
                        </label>
                        <div className="col-sm-9">
                          <div className="form-floating mb-3">
                            <input
                              ref={nameRef}
                              id="name"
                              type="text"
                              className="form-control"
                              placeholder={
                                client?.client_type === "corporate"
                                  ? "Contact Person"
                                  : "Name"
                              }
                              onChange={(e) => {
                                client?.client_type === "corporate"
                                  ? setClient({
                                      ...client,
                                      contact_person: e.target.value,
                                    })
                                  : setClient({
                                      ...client,
                                      name: e.target.value,
                                    });
                              }}
                              value={
                                client?.client_type === "corporate"
                                  ? client?.contact_person || ""
                                  : client?.name || ""
                              }
                              required={
                                client?.client_type === "corporate"
                                  ? true
                                  : false
                              }
                            />
                            <label htmlFor="name" className="text-primary">
                              {client?.client_type === "corporate"
                                ? "Contact Person"
                                : "Name"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label
                          htmlFor="phonenumber"
                          className="col-sm-3 form-label text-primary"
                        >
                          Phone Number
                        </label>
                        <div className="col-sm-9">
                          <div className="form-floating mb-3">
                            <input
                              id="phonenumber"
                              type="text"
                              className="form-control"
                              placeholder="Phone number"
                              onChange={(e) =>
                                setClient({
                                  ...client,
                                  phonenumber: e.target.value,
                                })
                              }
                              value={client?.phonenumber || ""}
                            />
                            <label
                              htmlFor="phonenumber"
                              className="text-primary"
                            >
                              Phone number
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label
                          htmlFor="email"
                          className="col-sm-3 form-label text-primary"
                        >
                          Email
                        </label>
                        <div className="col-sm-9">
                          <div className="form-floating mb-3">
                            <input
                              id="email"
                              type="email"
                              className="form-control"
                              placeholder="Email"
                              onChange={(e) =>
                                setClient({ ...client, email: e.target.value })
                              }
                              value={client?.email || ""}
                            />
                            <label htmlFor="email" className="text-primary">
                              Email
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label
                          htmlFor="address"
                          className="col-sm-3 form-label text-primary"
                        >
                          Address
                        </label>
                        <div className="col-sm-9">
                          <div className="form-floating mb-3">
                            <textarea
                              id="address"
                              className="form-control"
                              placeholder="Address"
                              rows="7"
                              onChange={(e) =>
                                setClient({
                                  ...client,
                                  address: e.target.value,
                                })
                              }
                              value={client?.address || ""}
                            ></textarea>
                            <label htmlFor="address" className="text-primary">
                              Address
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label
                          htmlFor="remarks"
                          className="col-sm-3 form-label text-primary"
                        >
                          Remarks
                        </label>
                        <div className="col-sm-9">
                          <div className="form-floating mb-3">
                            <textarea
                              id="remarks"
                              className="form-control"
                              placeholder="Remarks"
                              rows="7"
                              onChange={(e) =>
                                setClient({
                                  ...client,
                                  remarks: e.target.value,
                                })
                              }
                              value={client?.remarks || ""}
                            ></textarea>
                            <label htmlFor="remarks" className="text-primary">
                              Remarks
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label
                          htmlFor="relationManager"
                          className="col-sm-3 col-form-label text-primary"
                        >
                          Relation Manager
                        </label>
                        <div className="col-sm-9">
                          <Select
                            id="relationManager"
                            ref={rmRef}
                            options={
                              dropDowns && dropDowns["user"]
                                ? dropDowns["user"]
                                : []
                            }
                            onChange={(selectedOption) =>
                              setClient({
                                ...client,
                                relationManager: selectedOption,
                              })
                            }
                            value={client?.relationManager || ""}
                          />
                        </div>
                      </div>

                      {/* <!-- File Input --> */}
                      {/* <div className="row mb-3">
                        <label
                          htmlFor="attachments"
                          className="col-sm-3 col-form-label"
                        >
                          Attachments
                        </label>
                        <div className="col-sm-9">
                          <FileWidget
                            id="attachments"
                            // data={element}
                            onChange={(value) =>
                              setClient({
                                ...client,
                                attachments: JSON.stringify(value),
                              })
                            }
                            // onUploadedFileRemove={handleRemoveUploadedFile}
                            value={
                              client.attachments
                                ? JSON.parse(client.attachments)
                                : []
                            }
                          />
                        </div>
                      </div> */}
                      {/* <!-- END : File Input --> */}
                    </div>
                    <div className="card-footer">
                      <button className="btn btn-primary d-flex" type="submit">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default ClientForm;
